import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { IGoogleData } from 'components/google-places/useGooglePlaces';
import { Fields } from 'types/fields';
import messages from '../messages';
import GoogleAutocomplete from './googleAutocomplete';
import {
  AddressInputWrapperMobile,
  FormHeader,
  ValuationFormWrapperMobile,
} from './styles';

export interface ValuationFormMobileProps {
  setGoogleData: (googleData: IGoogleData & { full: string }) => void;
  homeValuationForm: UseFormReturn<Fields>;
}

export default function ValuationFormMobile({
  setGoogleData,
  homeValuationForm,
}: ValuationFormMobileProps) {
  const {
    formState: { errors },
    setValue,
    clearErrors,
    trigger,
    getValues,
  } = homeValuationForm;

  return (
    <ValuationFormWrapperMobile>
      <FormHeader>
        <FormattedMessage
          {...messages.formHeader}
          values={{ rsquo: <>&rsquo;</> }}
        />
      </FormHeader>
      <AddressInputWrapperMobile>
        <GoogleAutocomplete
          setValue={setValue}
          clearErrors={clearErrors}
          placeholder="Enter your address"
          name="address"
          error={errors.address}
          setGoogleData={setGoogleData}
          trigger={trigger}
          defaultValue={getValues('address')}
        />
      </AddressInputWrapperMobile>
    </ValuationFormWrapperMobile>
  );
}
